import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f60b53d0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Loading = _resolveComponent("Loading", true);

  var _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "play-loading",
    style: _normalizeStyle({
      height: _ctx.setHeight + 'px'
    })
  }, [_ctx.isIcon ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 0
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_Loading, {
        class: "is-loading"
      })];
    }),
    _: 1
    /* STABLE */

  })) : _createCommentVNode("v-if", true), _createElementVNode("span", null, _toDisplayString(_ctx.loadTitle), 1
  /* TEXT */
  )], 4
  /* STYLE */
  )]);
}